import React from 'react';

import LiveChatLayout from '~/account/components/LiveChatLayout';

import createPage from '../registry';

const LiveChat = () => {
  return <LiveChatLayout />;
};

export default createPage(LiveChat);
